export default __webpack_public_path__ + "8105081a4719823c0d804ceaf40afc3e.png";